import { getLargestProductPictureFormat } from '@/modules/pictures/helpers/getLargestProductPictureFormat';
import { type ProductBySlugResponse } from '@/modules/product/aliases';
import {
  hasThumbnailFormats,
  toProductPicture,
  toProductVideo,
} from '@/modules/product/helpers/toProductMedia';

export function getPictureThumbnailUrls(
  pictures: ProductBySlugResponse['pictures'] | undefined
): string[] {
  return (pictures ?? [])
    .map(toProductPicture)
    .map((picture) => getLargestProductPictureFormat(picture.formats).url);
}

export function getVideoThumbnailUrls(
  videos: ProductBySlugResponse['videos']
): string[] {
  return (videos ?? [])
    .map(toProductVideo)
    .filter(hasThumbnailFormats)
    .map(
      (video) => getLargestProductPictureFormat(video.thumbnail.formats).url
    );
}
